import IService from '../IService';
import app from 'app';

export default IService.extend({
  xhrGetPreferred: null,
  xhrGetAll: null,

  abortGetPreferred() {
    if (app.xhrExpected(this.xhrGetPreferred)) {
      this.xhrGetPreferred.abort();
      this.xhrGetPreferred = null;
    }
  },

  getPreferred(options) {
    const url = '/api/v1/producedStoryTemplatePreviews/preferred';
    options = _.options(options, {
      size: 50,
    });
    const rv = new _.ColdPromise();

    this.xhrGetPreferred = $.ajax({
      url: app.apiUrl(url),
      type: 'GET',
      data: options,

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      dataType: 'json',
      success(response) {
        if (_.isArray(response)) {
          rv.resolve({
            templates: response,
            noMore: !response || !response.length,
          });
        } else {
          rv.reject({ error: 'BAD_RESPONSE' });
        }
      },
    }).always(() => {
      this.xhrGetPreferred = null;
    });

    return rv;
  },

  addToMyTemplates({
    sourceStoryId,
    newTitle,
    destProgrammerId,
    storyStartPoint,
    brandId,
    themeId,
  }) {
    const rv = new _.ColdPromise();

    $.ajax({
      url: app.apiUrl(`/api/v1/producedStoryTemplates/${sourceStoryId}`),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        newTitle,
        destProgrammerId,
        storyStartPoint,
        destBrandId: brandId,
        destThemeId: themeId,
        resetCategories: true,
      }),

      dataType: 'json',

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      success() {
        rv.resolve();
      },
    });

    return rv;
  },

  touchTemplate(storyId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl(`/api/v1/producedStoryTemplates/${storyId}/touch`),
        type: 'GET',

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        success: resolve,
      });
    });
  },

  editMetadata(data) {
    return new Promise((resolve, reject) => {
      if (!data.storyId || !data.categoryIds) {
        reject({ error: 'missing required field' });
        return;
      }

      $.ajax({
        url: app.apiUrl(
          `/api/v1/producedStoryTemplates/${data.storyId}/metadata`
        ),
        type: 'PUT',

        contentType: 'application/json',
        data: JSON.stringify(data),

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        success: resolve,
      });
    });
  },

  abortGetAll() {
    if (app.xhrExpected(this.xhrGetAll)) {
      this.xhrGetAll.abort();
      this.xhrGetAll = null;
    }
  },

  getAll(options) {
    return new Promise((resolve, reject) => {
      options = _.options(options, {
        size: 50,
        page: 0,
        q: undefined,
        sharedProgrammerIds: undefined,
        brandIds: undefined,
        categoryIds: undefined,
        voiceOver: undefined,
        language: undefined,
        // in seconds
        minimumDuration: 0,
        maximumDuration: app.TIME.MAX_STORY_DURATION,
        ignoreSelectedProducedStoryTemplates: true,
        searchForUnCategorized: undefined,
      });

      if (_.isEmpty(options.sharedProgrammerIds) && !options.channelId) {
        return resolve({ templates: [], noMore: true });
      }

      this.xhrGetAll = $.ajax({
        url: app.apiUrl('/api/v1/producedStoryTemplates'),
        type: 'GET',
        data: options,

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success(response) {
          if (_.isArray(response)) {
            resolve({
              templates: response,
              noMore: !response || !response.length,
            });
          } else {
            reject({ error: 'BAD_RESPONSE' });
          }
        },
      }).always(() => {
        this.xhrGetAll = null;
      });
    });
  },

  createDraftStoryFromProducedStoryTemplate({
    storyId,
    newTitle,
    destProgrammerId,
    storyStartPoint,
    brandId,
    themeId,
  }) {
    const deferred = new $.Deferred();

    console.log('\u26A1createDraftStoryFromProducedStoryTemplate\u26A1');
    $.ajax({
      url: app.apiUrl(`/api/v1/producedStoryTemplates/${storyId}/draftStories`),
      type: 'POST',

      contentType: 'application/json',
      data: JSON.stringify({
        newTitle,
        destProgrammerId,
        storyStartPoint,
        destBrandId: brandId,
        destThemeId: themeId,
      }),

      error: (jqXHR, textStatus) => {
        if ('abort' === textStatus) {
          deferred.reject(this.createError(jqXHR));
        } else {
          app.dialog.serverError(this.createError(jqXHR)).then(deferred.reject);
        }
      },

      dataType: 'json',
      success: (res) => {
        deferred.resolve(res);
      },
    });

    return deferred.promise();
  },

  getAiTemplatesCount() {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl('/api/v1/aiStories'),
        type: 'GET',
        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },
        dataType: 'json',
        success: resolve,
      });
    });
  },
  createDraftStoryTemplateFromProducedStoryTemplate({
    storyId,
    newTitle,
    destProgrammerId,
    storyStartPoint,
    brandId,
    themeId,
    resetCategories,
  }) {
    const deferred = new $.Deferred();

    console.log(
      '\u26A1createDraftStoryTemplateFromProducedStoryTemplate\u26A1'
    );
    $.ajax({
      url: app.apiUrl(
        `/api/v1/producedStoryTemplates/${storyId}/draftStoryTemplates`
      ),
      type: 'POST',

      contentType: 'application/json',
      data: JSON.stringify({
        newTitle,
        destProgrammerId,
        storyStartPoint,
        destBrandId: brandId,
        destThemeId: themeId,
        resetCategories,
      }),

      error: (jqXHR, textStatus) => {
        if ('abort' === textStatus) {
          deferred.reject(this.createError(jqXHR));
        } else {
          app.dialog.serverError(this.createError(jqXHR)).then(deferred.reject);
        }
      },

      dataType: 'json',
      success: (res) => {
        deferred.resolve(res);
      },
    });

    return deferred.promise();
  },
});
